<template>
  <div class="patrolPlanDetails commonWrap">
    <div style="width: 98%; height: 97%">
      <OriginalTable :tableList="tableData" :tableHead="tabHead"/>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import OriginalTable from "@/components/table/OriginalTable.vue";
export default {
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  components:{
    OriginalTable
  },
  data() {
    return {
      tabHead: [],
      tableData: [],
    };
  },
  methods: {
    async getPointDelete() {
      let res = await api.patrolPlanPointDelete({
        taskId: this.detailData.taskId,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v) => {
          v.time = v.actTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.actTime))
            : "";
        });
      }
    },
    getTabHead() {
      if (this.$route.path == "/patrolPlan") {
        this.tabHead = [
          { label: "巡检点", prop: "pointName" },
          { label: "巡检时间", prop: "time" },
          { label: "巡检人", prop: "staffName" },
        ];
      } else if (this.$route.path == "/maintainPlan") {
        this.tabHead = [
          { label: "设备名称", prop: "pointName" },
          { label: "保养时间", prop: "time" },
          { label: "保养人", prop: "staffName" },
        ];
      }
    },
  },
  created() {
    this.getTabHead();
    if (this.detailData.taskId) {
      this.getPointDelete();
    }
  },
};
</script>

<style lang="scss" scoped>
.patrolPlanDetails {
  width: 98%;
  height: 98%;
  margin: 0 auto;
  @include setFlexCenter;
}
</style>